import { BrandKey } from '../../../__generated__/queries-web';
import { ceriseBrandkeys } from '../../../utils/brands';

export const AUTHORIZED_BRAND_FOR_EDITORIAL_ALERT = [
  BrandKey.UKSAS,
  BrandKey.DESAS,
  BrandKey.GEO,
  BrandKey.TEL,
  BrandKey.VOI,
  BrandKey.GAL,
  BrandKey.BIN,
  BrandKey.CAP,
  BrandKey.FAC,
  BrandKey.HBR,
  BrandKey.HBZ,
  BrandKey.CAC,
  BrandKey.NEO,
  BrandKey.TLS,
  BrandKey.TGC,
  BrandKey.CAM,
  BrandKey.TESTBRAND,
  ...ceriseBrandkeys,
];
